import {
  AllFlyerFilters,
  District,
  Flyer,
  Subscription,
} from '@/graphql/types';
import { makeVar } from '@apollo/client';

export const districtVar = makeVar<DistrictWithId | null>(null);

export const flyerboardAllFiltersVar = makeVar<AllFlyerFilters | null>(null);

export const subscriptionsVar = makeVar<Subscription[]>([]);

export const allSubscriptionsVar = makeVar<Subscription[]>([]);

export const flyerboardActiveFiltersVar = makeVar<{
  grades_age: string[];
  types: string[];
}>({
  grades_age: [],
  types: [],
});

export const flyerVar = makeVar<Flyer | null>(null);

export const userInformationVar = makeVar<{
  email: string;
  firstName: string;
  lastName: string;
  id: number;
} | null>(null);

export const flyerboardFlyersAmountVar = makeVar<number>(0);

export const openLoginDrawerVar = makeVar<boolean>(false);

export const showMagicLinkSuccessVar = makeVar<boolean>(false);

export const loginEmailVar = makeVar<string>('');

type DistrictWithId = {
  districtId: District['districtId'];
} & Partial<Omit<District, 'districtId'>>;
